// 「문의하기」(/support) 진입점 노출 — 서버 support_inquiry_visible() (2026-10-23 대표 「문의하기는 11월 1일부터」)
//
// 서버 판정 = 기존 스위치 creator_notice_rollout 켜짐 OR 지금 ≥ app_config.support_inquiry_open.from(2026-11-01 0시 KST).
// 기존 스위치는 홈 「알림 채널 등록」 띠까지 같이 켜므로, 문의하기 진입점(상단바·설정·문의 화면·푸터)만 이 판정을 본다.
//
// 🔒 규칙 — creatorNoticeRollout.js 와 같다
//   · 실패하면 숨김(fail-closed). · 어드민은 미리보기로 늘 본다. · 세션 동안 한 번 읽고 모듈 캐시.
// 훅은 src/hooks/useSupportInquiryVisible.js · 테스트 supportInquiryOpen.test.js · 마이그레이션 20261115100000
import { supabase } from "./supabaseClient";
import { isAdminRole } from "./creatorNoticeRollout";

export const SUPPORT_INQUIRY_VISIBLE_RPC = "support_inquiry_visible";

let cache = null; // { open: boolean, error: string|null }
let inflight = null;

export function resolveSupportVisible({ open, role }) {
  return open === true || isAdminRole(role);
}

export function getSupportInquiryOpenCache() {
  return cache;
}

/** 테스트용 */
export function resetSupportInquiryOpenCache() {
  cache = null;
  inflight = null;
}

/** 한 번 읽는다. 실패하면 { open:false, error } — throw 하지 않는다 */
export function fetchSupportInquiryOpen({ force = false } = {}) {
  if (cache && !force) return Promise.resolve(cache);
  if (inflight && !force) return inflight;
  inflight = Promise.resolve()
    .then(() => supabase.rpc(SUPPORT_INQUIRY_VISIBLE_RPC))
    .then(({ data, error }) => {
      cache = error ? { open: false, error: String(error.message || error) } : { open: data === true, error: null };
      return cache;
    })
    .catch((e) => {
      cache = { open: false, error: String(e?.message || e) };
      return cache;
    })
    .finally(() => { inflight = null; });
  return inflight;
}
